module.exports = __webpack_public_path__ + "static/img/docer.e2e3dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docer.png
// module id = uxv4
// module chunks = 0